import { render, staticRenderFns } from "./OctSalonDashboard.vue?vue&type=template&id=7b37fa63&scoped=true&"
import script from "./OctSalonDashboard.vue?vue&type=script&lang=js&"
export * from "./OctSalonDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OctSalonDashboard.vue?vue&type=style&index=0&id=7b37fa63&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37fa63",
  null
  
)

export default component.exports